$(".training__studies__button").on('click', (e) => {
    let button = $(e.currentTarget);
    button.addClass('is-active');
    button.one('animationend', function(){
        $(this).removeClass('is-active');
    });

    var nextItem = $(".training__studies__content:visible").next(".training__studies__content");
    if (nextItem.length == 0) {
        nextItem = $(".training__studies__content:first");
    }
    $(".training__studies__content").hide();
    nextItem.show().css({"display": "flex"});
});